// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__JcThm","menu-item-icon":"Menu_menu-item-icon__gWHZA","menu-item-contributors":"Menu_menu-item-contributors__Thite"};